import React from 'react'
import {Card, CardContent, Stack, Typography} from '@mui/material'

// Shared frame for every chart/list section so titles, spacing and actions look the same.
const SectionCard = ({title, subtitle, action, children, sx}) => (
    <Card sx={{height: '100%', ...sx}}>
        <CardContent sx={{p: 3, height: '100%', display: 'flex', flexDirection: 'column', gap: 2}}>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                flexWrap="wrap"
                gap={1.5}>
                <Stack spacing={0.25}>
                    <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                        {title}
                    </Typography>
                    {typeof subtitle === 'string' ? (
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    ) : (
                        subtitle
                    )}
                </Stack>
                {action}
            </Stack>
            {children}
        </CardContent>
    </Card>
)

export default SectionCard
